import { render } from "./AppPDFViewerV2.vue?vue&type=template&id=184aba6f&ts=true"
import script from "./AppPDFViewerV2.vue?vue&type=script&lang=ts"
export * from "./AppPDFViewerV2.vue?vue&type=script&lang=ts"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__